/**
 * Sekme kaydı — Power BI raporundaki sıra korunur.
 *
 * Her sekme kendi config'ini ve kaç satırlık bir grid'e yayıldığını bildirir;
 * `SmartOptDashboard` satır yüksekliğini buna göre ölçer, böylece her sekme
 * kendi yoğunluğunda tek ekrana oturur.
 */
import { buildOzetConfig, OZET_ROWS } from "./ozet";
import { buildUretimConfig, URETIM_ROWS } from "./uretim";
import { buildGovdeStokConfig, GOVDE_STOK_ROWS } from "./govdeStok";
import { buildGovdeOnStokConfig, GOVDE_ON_STOK_ROWS } from "./govdeOnStok";
import { ARZ_TALEP_ROWS, buildArzTalepConfig } from "./arzTalep";

export const TABS = [
  { key: "ozet", label: "Özet", rows: OZET_ROWS, build: buildOzetConfig },
  { key: "uretim", label: "Üretim", rows: URETIM_ROWS, build: buildUretimConfig },
  {
    key: "govde-stok",
    label: "Gövde Stok Yönetimi",
    rows: GOVDE_STOK_ROWS,
    build: buildGovdeStokConfig,
  },
  {
    key: "govde-on-stok",
    label: "Gövde Ön Stok Yönetimi",
    rows: GOVDE_ON_STOK_ROWS,
    build: buildGovdeOnStokConfig,
  },
  // Raporda yok; mailden gelen istekle eklendi.
  { key: "arz-talep", label: "Arz / Talep", rows: ARZ_TALEP_ROWS, build: buildArzTalepConfig },
];
